import React from 'react';
import PropTypes from 'prop-types';
import styles from '../ArticleComponents.module.css';

import { Timeline } from 'react-twitter-widgets';

export default function TwitterComponent({ name }) {
	return (
		<div className={styles['component-twitter']}>
			<Timeline
				dataSource={{
					sourceType: 'profile',
					screenName: name,
				}}
				options={{
					height: '100%',
				}}
			/>
		</div>
	);
}

TwitterComponent.propTypes = {
	name: PropTypes.string.isRequired,
};